import api from './api';

export interface CatalogLimits {
  currentCount: number;
  maxItems: number | null;
  remaining: number | null;
}

export async function getCatalogLimits(ownerId?: string | null): Promise<CatalogLimits> {
  const params = ownerId ? `?owner_id=${encodeURIComponent(ownerId)}` : '';
  const response = await api.get<CatalogLimits>(`/api/catalogs/limits${params}`);
  return response.data;
}
